import React, { useEffect, useState } from 'react';
import { useContext } from './../Context';

const ImagePreview = () => {
    const { globalState } = useContext();
    const { selectedFile, uploadMode } = globalState;
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (uploadMode === 'dropbox' || uploadMode === 'drive') {
            setPreview(selectedFile.link);
        }

        if (uploadMode === 'blob' && selectedFile) {
            // Create an object URL from the blob
            const objectUrl = URL.createObjectURL(selectedFile);
            setPreview(objectUrl);

            // Revoke the object URL to free up memory when the component unmounts
            return () => URL.revokeObjectURL(objectUrl);
        }

        if (uploadMode === 'file' && selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result); // Base64 representation of the image
            };
            reader.readAsDataURL(selectedFile);
        }
    }, [selectedFile, uploadMode]);

    return (
        preview && (
            <div className='image-upload__preview'>
                <img src={preview} alt="Preview" />
            </div>
        )
    );
};

export default ImagePreview;
